import _toConsumableArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { util } from '@citation-js/core';
import config from './config';
import { SPECS } from './spec';
import CONVERTERS from './converters';
import DATA_TYPES from './dataTypes';
var LINE_MATCH = /^[A-Z][A-Z0-9] {2}-( |$)/;
var LINE_SPLIT = / {2}-(?: |$)/;
var TRANSLATORS = new Map();

function prepareTranslator(spec) {
  if (!TRANSLATORS.has(spec)) {
    var _iterator = _createForOfIteratorHelper(spec),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mapping = _step.value;

        if (mapping.target in DATA_TYPES) {
          mapping.convert = CONVERTERS[DATA_TYPES[mapping.target]];
        }

        if (mapping.convert && mapping.convert.keepAll === true) {
          continue;
        }

        if (Array.isArray(mapping.source)) {
          if (mapping.convert) {
            (function () {
              var _mapping$convert = mapping.convert,
                  _toSource = _mapping$convert.toSource,
                  _toTarget = _mapping$convert.toTarget;
              mapping.convert = {
                toTarget: function toTarget() {
                  var _CONVERTERS$ANY;

                  return _toTarget((_CONVERTERS$ANY = CONVERTERS.ANY).toTarget.apply(_CONVERTERS$ANY, arguments));
                },
                toSource: function toSource() {
                  return CONVERTERS.ANY.toSource(_toSource.apply(void 0, arguments));
                }
              };
            })();
          } else {
            mapping.convert = CONVERTERS.ANY;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    TRANSLATORS.set(spec, new util.Translator(spec));
  }

  return TRANSLATORS.get(spec);
}

export function parse(text) {
  var entries = [];
  var lastEntry;
  var lastTag;

  var _iterator2 = _createForOfIteratorHelper(text.split(/\r?\n/)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var line = _step2.value;
      line = line.trim();

      if (!LINE_MATCH.test(line)) {
        if (lastEntry && lastTag) {
          lastEntry[lastTag] += ' ' + line;
        }

        continue;
      }

      var _line$split = line.split(LINE_SPLIT),
          _line$split2 = _slicedToArray(_line$split, 2),
          tag = _line$split2[0],
          value = _line$split2[1];

      switch (tag) {
        case 'ER':
          lastEntry = undefined;
          lastTag = undefined;
          break;

        case 'TY':
          lastEntry = {};
          entries.push(lastEntry);

        default:
          if (Array.isArray(lastEntry[tag])) {
            lastEntry[tag].push(value);
          } else {
            lastEntry[tag] = lastEntry[tag] ? [lastEntry[tag], value] : value;
          }

          lastTag = tag;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return entries;
}
export function parseOld(data) {
  return prepareTranslator(SPECS.old).convertToTarget(data);
}
export function parseNew(data) {
  return prepareTranslator(SPECS["new"]).convertToTarget(data);
}
export function parseMixed(data) {
  return prepareTranslator(SPECS.mixed).convertToTarget(data);
}
export function format(data) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? type || 'text' : _ref$format;

  var entries = data.map(prepareTranslator(SPECS[config.outputSpec]).convertToSource);

  if (format === 'object') {
    return entries;
  }

  return entries.map(function (entry) {
    var tags = [];

    var _loop = function _loop(tag) {
      if (tag === 'TY') {
        return "continue";
      }

      tags.push.apply(tags, _toConsumableArray([].concat(entry[tag]).map(function (value) {
        return "".concat(tag, "  - ").concat(value.toString().replace(/(.{70})/g, '$1\n'));
      })));
    };

    for (var tag in entry) {
      var _ret = _loop(tag);

      if (_ret === "continue") continue;
    }

    tags.unshift("TY  - ".concat(entry.TY));
    tags.push('ER  - ');
    return tags.join('\n');
  }).join('\n');
}